export default "__VITE_ASSET__DDS3aaPQ__"